import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getSuggestKeywords = (params, callback) => {
  const controller = new AbortController();
  const axios = AxiosConfigExplore();
  const url = `/suggest/keywords/${params}`;
  axios
    .get(url, {
      signal: controller.signal,
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
  return controller;
};

export const getRelatedKeywords = async ({ keywords = [], top_k, entity }) => {
  const axios = AxiosConfigExplore();
  let url = `/related_keywords`;

  let querySearchParams = new URLSearchParams();
  keywords.forEach((keyword) => {
    if (keyword) {
      querySearchParams.append("query", keyword);
    }
  });
  url += `?${querySearchParams.toString()}`;

  if (top_k) {
    url += `&top_k=${top_k}`;
  }

  if (entity) {
    url += `&entity=${entity}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
